module.exports = __webpack_public_path__ + "img/randd.0d7b9634.png";